export const getAcronym = (text: string | unknown): string | null =>
  typeof text !== 'string'
    ? null
    : text
        .split(' ')
        .map((item) => item.charAt(0))
        .join('');
